import { Star } from '@phosphor-icons/react';
import { Bell } from 'phosphor-react';
import { useEffect, useMemo, useState } from 'react';
import styles from './home.module.css';
import { HeaderCard } from './components/HeaderCard';
import pattern1 from '../../../assets/img/pattern-1.svg';
import pattern2 from '../../../assets/img/pattern-2.svg';
import pattern3 from '../../../assets/img/pattern-3.svg';
import { ActionCard } from '../../gasStation/Home/components/ActionCard';
import { useHomeData } from './useHomeData';
import { useHomeCards } from './useHomeCards';
import { removeObjectFromLocal } from '../../../utils/localStorage';
import { AnswerIdDetectionModal } from './components/AnswerIdDetectionModal';
import { ModalAnnouncement } from '../../../shared/ModalAnnouncement';
import { getLogo } from '../../../utils/getLogo';
import { useAuth } from '../../../hooks/useAuth';
import { AnnouncementBanner } from './components/AnnouncementBanner';
import { AccountControlHeader } from '../AccountControlHeader';

export const Home = () => {
  const {
    handleSingOut,
    // isVisitor,
    loadingData,
    // newAnswerQuotations,
    amountNotifications,
    // newCustomers,
    newQuotationsHome,
    hasUnseenQuotation,
    hasUnseenAnswerQuotation,
    isOpenAnnouncement,
    handleCloseModal,
    // newQuotations,
    totalAssessments,
    // totalServices,
    totalAnnouncements,
    announcements,
    navigate,
    isAnswerQuotationModalOpen,
    handleAnswerQuotation,
    handleCancelAnswerQuotation,
  } = useHomeData();

  const { content } = useHomeCards({
    newQuotationAnswers: hasUnseenAnswerQuotation,
    newQuotations: hasUnseenQuotation,
  });

  const logo = useMemo(() => getLogo(), []);

  const { workshop: data } = useAuth();

  const [isOpenModalTotalAnnouncements, setIsOpenModalTotalAnnouncements] =
    useState(false);
  const [initialStepNavBarAnnouncement, setInitialStepNavBarAnnouncement] =
    useState(0);
  // Temporário - Constante para filtrar anúncios únicos quando o back gerar 2 históricos para o mesmo anúncio
  const anunciosUnicos = useMemo(
    () =>
      (totalAnnouncements ?? []).filter(
        (anuncio, index, self) =>
          index ===
          self.findIndex(
            a =>
              a.announcement.id_announcement ===
              anuncio.announcement.id_announcement,
          ),
      ),
    [totalAnnouncements],
  );

  const handleOpenModalTotalAnnouncements = (initialStep: number) => {
    setIsOpenModalTotalAnnouncements(true);
    setInitialStepNavBarAnnouncement(initialStep);
  };

  const handleCloseModalTotalAnnouncements = () => {
    setIsOpenModalTotalAnnouncements(false);
  };
 
  useEffect(() => {
    removeObjectFromLocal('@local-order-service');
  }, []);

  const { user } = useAuth();
  const userPermissions = user?.permissions ?? [];

  const hasOrderServicePermission = userPermissions.some(
    permission => permission.code === 'OS',
  );

  return (
    <>
      {announcements && announcements?.length > 0 && (
        <ModalAnnouncement
          // key={announcement.announcement.id_announcement}
          title="Novas Atualizações"
          isOpen={isOpenAnnouncement}
          onClose={() => handleCloseModal()}
          announcements={announcements}
          size="large"
        />
      )}
      {isOpenModalTotalAnnouncements &&
        totalAnnouncements &&
        totalAnnouncements.length > 0 && (
          <ModalAnnouncement
            title="Novas Atualizações"
            isOpen={isOpenModalTotalAnnouncements}
            onClose={() => handleCloseModalTotalAnnouncements()}
            // announcements={totalAnnouncements}
            announcements={anunciosUnicos}
            initialStepNavBarAnnouncement={initialStepNavBarAnnouncement}
            size="large"
          />
        )}
      <AnswerIdDetectionModal
        isOpen={isAnswerQuotationModalOpen}
        onClose={handleCancelAnswerQuotation}
        onConfirm={handleAnswerQuotation}
      />
      <main className={styles.main}>
        <header className={styles.header}>
          <div className={styles['logo-wrapper']}>
            <img src={logo} className={styles.logo} alt="autocenter logo" />
          </div>
          <div className={styles.statistics}>
            <div className={styles['statistics-wrapper']}>
              {totalAnnouncements && totalAnnouncements.length > 0 && (
                <AnnouncementBanner
                  announcements={totalAnnouncements}
                  handleOpenModalTotalAnnouncements={
                    handleOpenModalTotalAnnouncements
                  }
                />
              )}
              <div className={styles['statistics-cards']}>
                {!hasOrderServicePermission && (
                  <HeaderCard
                    icon={
                      <Bell
                        size={window.innerWidth > 480 ? 18 : 14}
                        weight="bold"
                      />
                    }
                    label="Atualizações de Cotação"
                    value={newQuotationsHome}
                    // value={quotationNotifications.length}
                    onClick={() => navigate('/quotation-notification')}
                    loading={loadingData}
                  />
                )}
                <HeaderCard
                  icon={
                    <Bell
                      size={window.innerWidth > 480 ? 18 : 14}
                      weight="bold"
                    />
                  }
                  label="Notificações"
                  value={amountNotifications}
                  emphasis={!!(amountNotifications > 0)}
                  // value={
                  //   generalNotifications.filter(
                  //     notification => notification.read === false,
                  //   ).length
                  // }
                  // emphasis={
                  //   !!generalNotifications.find(
                  //     notification => notification.read === false,
                  //   )
                  // }
                  onClick={() => navigate('/notifications')}
                  loading={loadingData}
                />
                {/* <HeaderCard
                icon={
                  <Wrench
                    size={window.innerWidth > 480 ? 28 : 24}
                    weight="bold"
                  />
                }
                label="Total de serviços/mês"
                value={totalServices}
                loading={loadingData}
              /> */}
                {/* <HeaderCard
                icon={
                  <Users
                    size={window.innerWidth > 480 ? 28 : 24}
                    weight="bold"
                  />
                }
                label="Novos clientes"
                value={newCustomers}
                loading={loadingData}
              /> */}
                <HeaderCard
                  icon={
                    <Star
                      size={window.innerWidth > 480 ? 18 : 14}
                      weight="bold"
                    />
                  }
                  label="Avaliações"
                  value={totalAssessments}
                  formatted
                  onClick={() => navigate('/assessment')}
                  loading={loadingData}
                />
              </div>
            </div>
            <img src={pattern1} className={styles.pattern} alt="" />
            <AccountControlHeader
              username={data?.fantasy_name}
              route="/register"
              handleSingOut={handleSingOut}
            />
          </div>
        </header>
        <section className={styles.actions}>
          {/* {isVisitor && (
            <ActionCard
              description="Clique aqui para seu mês grátis e acesse recursos imperdíveis"
              icon={
                <Star
                  size={window.innerWidth === 480 ? 38 : 48}
                  weight="bold"
                  color="#007A37"
                />
              }
              title="Faça parte do Autocenter"
              path=""
              onClick={() => {
                sendWhatsappMessage(
                  'Olá! Quero fazer parte do Autocenter',
                  '+558791080605',
                );
              }}
            />
          )} */}
          {content &&
            content.map(item => (
              <ActionCard
                description={item.description}
                icon={item.icone}
                title={item.title}
                path={item.uri}
                notifications={item.notifications}
                key={item.title}
              />
            ))}
          <img src={pattern2} className={styles.pattern} alt="" />
          <img
            src={pattern3}
            className={`${styles.pattern} ${styles.mobile}`}
            alt=""
          />
        </section>
        {/* <button
          type="button"
          className={styles.singout}
          onClick={handleSingOut}
        >
          <SignOut size={32} color={COLORS.RED} weight="bold" />
        </button> */}
        {/* <p>
          {baseURL === 'https://testserver.autocenterapp.com/' ? `Beta` : ''}
        </p> */}
      </main>
    </>
  );
};
